import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'ga0004',
    ecrans: ['00-2']
});

